import React, {PureComponent, CSSProperties} from 'react'
import cxs from 'cxs/component'
import Theme from 'Theme'
import {T} from 'helpers/i18n'
import {toDate, toMoney} from 'helpers/Format'
import {dateMonthsBefore} from 'helpers/Date'
import {Modal, Table} from 'components'
import {Button, DatePicker, Select} from 'elements'

interface Props<P> {
  header?: string[]
  items: P[]
  loading?: boolean
  filterDate?: boolean
  keyExtractor(item: P): string
  format(items: P[])
  total?(items: P[])
  onSelectItem?(item: P): void
}

interface State {
  from: Date
  to: Date
  fromVisible: boolean
  toVisible: boolean
}

class Report<P> extends PureComponent<Props<P>, State> {
  state: State = {
    from: dateMonthsBefore(new Date(), 1),
    to: new Date(),
    fromVisible: false,
    toVisible: false
  }

  render() {
    const {header, items, total, format, ...props} = this.props
    const {from, to, fromVisible, toVisible} = this.state
    const filterDate = props.filterDate === undefined? true : props.filterDate
    const filteredItems = filterDate? this.filteredItems(items) : items
    const fomatedItems = format(filteredItems)

    return (
      <div>
        {props.filterDate && <Header>
          {T('from')}:{' '}
          <Button onClick={this.toggleFromModal}>{toDate(from)}</Button>
          {T('to')}: <Button onClick={this.toggleToModal}>{toDate(to)}</Button>
        </Header>}
        <Table onSelectItem={this.handleOnSelectItem} {...props} items={fomatedItems} header={header} search={false} />
        {total && (
          <Total>
            {T('total')} {toMoney(total(filteredItems))}
          </Total>
        )}
        {fromVisible && (
          <Modal title={T('from')}>
            <DatePicker
              name={'from'}
              date={from}
              onChange={this.handleFromChange}
            />
          </Modal>
        )}
        {toVisible && (
          <Modal title={T('to')}>
            <DatePicker name={'to'} date={to} onChange={this.handleToChange} />
          </Modal>
        )}
      </div>
    )
  }

  private handleOnSelectItem = ( item: any ) => {
    console.log( 'TicketsReport - handleOnSelectItem - item: ', item)
    const { items } = this.props
    const ticket = items.filter((value: any) => value.id === item.id)
    this.props.onSelectItem(ticket[0] as any)
  }

  private toggleFromModal = () =>
    this.setState({fromVisible: !this.state.fromVisible})

  private toggleToModal = () =>
    this.setState({toVisible: !this.state.toVisible})

  private handleFromChange = (_, from) => {
    this.toggleFromModal()
    this.setState({from})
  }

  private handleToChange = (_, to) => {
    this.toggleToModal()
    this.setState({to})
  }

  private filteredItems = items => {
    const {from, to} = this.state
    // return items
    return items.filter(item => item.date < to && item.date > from)
  }
}

export default Report

const Header = cxs('div')({
  paddingLeft: Theme.size.space[1]
} as CSSProperties)

const Total = cxs('div')({
  padding: Theme.size.space[1],
  borderTop: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
  textAlign: 'right'
} as CSSProperties)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Reports/components/Report.tsx